import { useEffect } from "react";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap"

export default function NewVersionAlertModal() {
  const showNewVersionAlert = localStorage.getItem("isNewVersionAlert") === "true";
  const [showModal, setShowModal] = useState(showNewVersionAlert);

  useEffect(() => {
    if (new Date() > new Date("2025-07-15")) {
      setShowModal(false);
    }
    
    if (showNewVersionAlert) {
      localStorage.setItem("isNewVersionAlert", "false");
    }
  }, []);

  return (
      <Modal
        show={showModal}
        centered
        style={{ textAlign: "center" }}
      >
        <Modal.Header closeButton className="modal-footer">
          <Modal.Title>
            Aviso de nova versão
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>
            Prezado cliente Zeus Pix, é com imensa felicidade é que viemos comunicar que a partir do dia 15/07/2025 o lançamento da nova versão 2.0 do sistema Zeus Pix estará disponível para todos os clientes.
            <br />
            <br />
            A versão 2.0 traz consigo uma série de melhorias e novas funcionalidades, como:
            <br />
            <br />
            - Nova interface de usuário mais intuitiva e amigável.
            <br />
            - Melhorias de performance e estabilidade.
            <br />
            - Novas funcionalidades de monitoramento e controle.
            </p>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              OK
            </Button>
        </Modal.Footer>
      </Modal>
    )
}